import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { ProductCardRectZoom } from '@Components/BigBrowse/bb2/meshes2/primitives/ProductCardRectZoom';
import { a } from '@react-spring/three';

type Props = {
  gridCard: GridCard<PlaneTypes.Layout_Merchandiser>;
  onClick?: () => void;
  animatedIn: boolean;
  zRange?: [number, number]; // Z-indexes allowed for internal components
};

export function MerchandiserCentralImage({
  gridCard,
  onClick,
  animatedIn,
  zRange = [0, 0.1],
}: Props) {
  const { data } = gridCard;
  const { centralImagePosition, centralImageSize } = data!.internals!;

  const [zMin, zMax] = zRange;
  const zSpan = zMax - zMin;

  return (
    <a.group position={[centralImagePosition.x, centralImagePosition.y, zMin]}>
      <ProductCardRectZoom
        position={{ x: 0, y: 0 }}
        size={centralImageSize}
        imageUrl={data!.dtoData.heroImageUrl}
        uniqueKey={gridCard.key!}
        hoverDisabled
        onClick={onClick}
        radius={40}
        zRange={[zMin, zMin + zSpan * 0.1]}
        animatedIn={animatedIn}
      />
    </a.group>
  );
}
